 export const DeployType = {
  prod: true,
  version : 1.9,
  gateway: "https://gateway.memploi.com"
 }